// segments
export const SEGMENTS_MAPPING = {
  FULL_GAME: 'Full Game',
  DLC_ALL_OTHER: 'DLC: All Other',
  DLC_EXPANSION: 'DLC: Expansion',
  DLC_CONTENT_PRE_PURCHASE_PASS: 'DLC: Content Pre-Purchase Pass',
  DLC_UNLOCKABLE_CONTENT_PASS: 'DLC: Unlockable Content Pass',
  MTX: 'MTX',
  SUBSCRIPTION: 'Subscription',
};

// segments名称
export const SEGMENTS_NAMES_MAPPING = {
  [SEGMENTS_MAPPING.FULL_GAME]: 'Base Game',
  [SEGMENTS_MAPPING.DLC_ALL_OTHER]: 'DLC: All Other',
  [SEGMENTS_MAPPING.DLC_EXPANSION]: 'DLC: Expansion',
  [SEGMENTS_MAPPING.DLC_CONTENT_PRE_PURCHASE_PASS]: 'DLC: Content Pre-Purchase Pass',
  [SEGMENTS_MAPPING.DLC_UNLOCKABLE_CONTENT_PASS]: 'DLC: Unlockable Content Pass',
  [SEGMENTS_MAPPING.MTX]: 'MTX',
  [SEGMENTS_MAPPING.SUBSCRIPTION]: 'Subscription',
};

// 全部segments
export const ALL_SEGMENTS = [
  SEGMENTS_MAPPING.FULL_GAME,
  SEGMENTS_MAPPING.DLC_ALL_OTHER,
  SEGMENTS_MAPPING.DLC_EXPANSION,
  SEGMENTS_MAPPING.DLC_CONTENT_PRE_PURCHASE_PASS,
  SEGMENTS_MAPPING.DLC_UNLOCKABLE_CONTENT_PASS,
  SEGMENTS_MAPPING.MTX,
  SEGMENTS_MAPPING.SUBSCRIPTION,
];
// segments的label key
export const SEGMENTS_NAMES_MAPPING_KEY = {
  [SEGMENTS_MAPPING.FULL_GAME]: 'dbi_segment_full_game_key',
  [SEGMENTS_MAPPING.DLC_ALL_OTHER]: 'dbi_segment_DLC_all_other_key',
  [SEGMENTS_MAPPING.DLC_EXPANSION]: 'dbi_segment_DLC_expansion_key',
  [SEGMENTS_MAPPING.DLC_CONTENT_PRE_PURCHASE_PASS]: 'dbi_segment_DLC_content_pre_purchase_pass_key',
  [SEGMENTS_MAPPING.DLC_UNLOCKABLE_CONTENT_PASS]: 'dbi_segment_DLC_unlockable_content_pass_key',
  [SEGMENTS_MAPPING.MTX]: 'dbi_segment_MTX_key',
  [SEGMENTS_MAPPING.SUBSCRIPTION]: 'dbi_segment_subscription_key',
};
// segments的tooltip
export const SEGMENTS_NAMES_MAPPING_TIP = {
  [SEGMENTS_MAPPING.FULL_GAME]: 'dbi_segment_full_game',
  [SEGMENTS_MAPPING.DLC_ALL_OTHER]: 'dbi_segment_DLC_all_other',
  [SEGMENTS_MAPPING.DLC_EXPANSION]: 'dbi_segment_DLC_expansion',
  [SEGMENTS_MAPPING.DLC_CONTENT_PRE_PURCHASE_PASS]: 'dbi_segment_DLC_content_pre_purchase_pass',
  [SEGMENTS_MAPPING.DLC_UNLOCKABLE_CONTENT_PASS]: 'dbi_segment_DLC_unlockable_content_pass',
  [SEGMENTS_MAPPING.MTX]: 'dbi_segment_MTX',
  [SEGMENTS_MAPPING.SUBSCRIPTION]: 'dbi_segment_subscription',
};
